import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { Navigate } from "react-router-dom"
import { useAuth } from "@/features/auth/AuthContext"
import { useEffectiveAdminAccess } from "@/features/admin/useEffectiveAdminAccess"
import { LoadingBlock } from "@/widgets/LoadingBlock"

type RequireAdminAccessProps = {
  children: ReactNode
}

/** Показывает контент только при наличии прав администрирования; редиректит на главную иначе */
export const RequireAdminAccess = ({ children }: RequireAdminAccessProps) => {
  const { t } = useTranslation()
  const { grantedPolicies } = useAuth()
  const { hasAnyAdminAccess, adminAccessResolved } = useEffectiveAdminAccess()
  const policiesResolved = grantedPolicies !== null

  if (!policiesResolved || !adminAccessResolved) {
    return <LoadingBlock variant="page" message={t("common.loading")} rootStyle={{ minHeight: "40vh" }} />
  }

  if (!hasAnyAdminAccess) {
    return <Navigate to="/" replace />
  }

  return children
}
